import { render, staticRenderFns } from "./VillageReports.vue?vue&type=template&id=1ceb470c&scoped=true"
import script from "./VillageReports.vue?vue&type=script&lang=js"
export * from "./VillageReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb470c",
  null
  
)

export default component.exports